import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import Aux from "../../hoc/_Aux/Aux";

const BUSINESS_TYPES = [
  { value: "Milonga", labelKey: "businessTypeMilonga" },
  { value: "Tango class / school", labelKey: "businessTypeClass" },
  { value: "Teacher", labelKey: "businessTypeTeacher" },
  { value: "Musician / orchestra", labelKey: "businessTypeMusician" },
  { value: "Festival / event", labelKey: "businessTypeFestival" },
  { value: "Other", labelKey: "businessTypeOther" },
];

class RequestAccess extends Component {
  state = {
    emailUser: "",
    businessType: "",
    chkTerms: false,
    errors: {},
    submitted: false,
    loading: false,
  };

  handleCheckboxChange = () => {
    this.setState((prev) => ({ chkTerms: !prev.chkTerms }));
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, errors: {} });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { emailUser, businessType } = this.state;
    const { dictionary } = this.props.lang;
    this.setState({ loading: true, errors: {} });

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/access-requests`,
        { emailUser: emailUser.trim(), businessType }
      );
      this.setState({ submitted: true, loading: false });
    } catch (err) {
      const errors = err.response?.data || { general: dictionary.somethingWentWrong };
      this.setState({ errors, loading: false });
      toast.error(dictionary.checkFormAndTryAgain);
    }
  };

  render() {
    const { emailUser, businessType, chkTerms, errors, submitted, loading } = this.state;
    const { dictionary } = this.props.lang;

    return (
      <Aux>
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <div className="card">
              <div className="card-body text-center">
                <div className="mb-4">
                  <i className="feather icon-send auth-icon" />
                </div>

                {submitted ? (
                  <>
                    <h3 className="mb-3" style={{ color: "#4e6ac5" }}>{dictionary.requestAccessSent}</h3>
                    <p className="text-muted mb-4">
                      {dictionary.requestAccessSentDesc}
                    </p>
                    <p className="mb-0 text-muted">
                      <NavLink to="/login">{dictionary.backToLogin}</NavLink>
                    </p>
                  </>
                ) : (
                  <>
                    <h3 className="mb-2">{dictionary.requestAccessTitle}</h3>
                    <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                      {dictionary.requestAccessSubtitle}
                    </p>
                    <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px 0", textAlign: "left" }}>
                      {[dictionary.requestAccessBullet1, dictionary.requestAccessBullet2, dictionary.requestAccessBullet3].map((b, i) => (
                        <li key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, fontSize: 13, color: "#555" }}>
                          <i className="feather icon-check-circle" style={{ color: "#22c55e", fontSize: 15, flexShrink: 0 }} />
                          {b}
                        </li>
                      ))}
                    </ul>

                    <form onSubmit={this.handleSubmit}>
                      <div className="mb-3 text-start">
                        <input
                          type="email"
                          name="emailUser"
                          value={emailUser}
                          onChange={this.handleChange}
                          placeholder={dictionary.emailAddress}
                          className={`form-control${errors.emailUser ? " is-invalid" : ""}`}
                          required
                        />
                        {errors.emailUser && (
                          <div className="invalid-feedback">{errors.emailUser}</div>
                        )}
                      </div>

                      <div className="mb-4 text-start">
                        <select
                          name="businessType"
                          value={businessType}
                          onChange={this.handleChange}
                          className={`form-control${errors.businessType ? " is-invalid" : ""}`}
                          required
                        >
                          <option value="">{dictionary.selectBusinessType}</option>
                          {BUSINESS_TYPES.map((t) => (
                            <option key={t.value} value={t.value}>{dictionary[t.labelKey]}</option>
                          ))}
                        </select>
                        {errors.businessType && (
                          <div className="invalid-feedback">{errors.businessType}</div>
                        )}
                      </div>

                      {errors.general && (
                        <p className="text-danger mb-3" style={{ fontSize: 13 }}>{errors.general}</p>
                      )}

                      <div className="d-flex align-items-start mb-4" style={{ gap: 10, textAlign: "left" }}>
                        <input
                          type="checkbox"
                          id="chkTerms"
                          name="chkTerms"
                          checked={chkTerms}
                          onChange={this.handleCheckboxChange}
                          style={{ marginTop: 3, flexShrink: 0 }}
                        />
                        <label htmlFor="chkTerms" style={{ fontSize: 13, color: "#666", cursor: "pointer", margin: 0 }}>
                          {dictionary.iAcceptThe}{" "}
                          <a href="/terms-of-use" target="_blank" rel="noreferrer" style={{ color: "#4e6ac5" }}>
                            {dictionary.termsOfUse}
                          </a>{" "}
                          {dictionary.and}{" "}
                          <a href="/privacy-policy" target="_blank" rel="noreferrer" style={{ color: "#4e6ac5" }}>
                            {dictionary.privacyPolicy}.
                          </a>
                        </label>
                      </div>

                      <div className="mb-3">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading || !emailUser || !businessType || !chkTerms}
                        >
                          {loading ? dictionary.sending : dictionary.requestAccess}
                        </button>
                      </div>
                    </form>

                    <p className="mb-0 text-muted">
                      {dictionary.alreadyHaveAccount}{" "}
                      <NavLink to="/login">{dictionary.login}</NavLink>
                      {" · "}
                      <NavLink to="/">{dictionary.goHome}</NavLink>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

RequestAccess.propTypes = {
  lang: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(RequestAccess);
